export enum SelectedCoworkingType {
  None,
  FlexibleWorkplace,
  FixedWorkplace,
  SeparateOffice,
}
